import { Notify } from "../notify";

export default () => ({
    data: {
        name: '',
        country: '',
        email: '',
        area: '',
        city: '',
        warehouse: '',
        phone: '',
        payment: '',
        delivery: '',
        street: '',
        building: '',
        flat: '',
        comment: '',
    },
    loading: false,
    errors: {},
    showAddress: false,
    
    init() {
        this.user();
    },

    form: {
        [':class']() {
            return this.loading ? 'disabled' : '';
        },

        ['@submit.prevent']() {
            this.submit();
        },
    },

    async user() {
        let response = await fetch('/api/account/user', {
            method: 'GET',
            headers: {
                'X-csrf-token': _token
            },
        });

        let result = await response.json();

        if(result.user !== undefined) {
            this.data.name = result.user.fullname;
            this.data.email = result.user.email;
            this.data.phone = result.user.phone;
            this.data.city = result.address[0].city;
            this.data.street = result.address[0].street;
            this.data.building = result.address[0].building;
            this.data.flat = result.address[0].flat;
        }
    },

    async submit() {
        this.loading = true;

        let form = this.$el;
        let formData = new FormData(form);
        let response = await fetch('/api/order', {
            method: 'POST',
            headers: {
                'X-csrf-token': _token
            },
            body: formData,
        });

        if (!response.ok) {
            this.loading = false;
            Notify.error(lex['form.internal_error']);
            return;
        }

        let result = await response.json();

        this.errors = result.errors;

        if (Object.keys(this.errors).length === 0) {
            window.location = result.redirect;
        }
        else {
            let error = this.errors.error !== undefined ? this.errors.error : lex['form.error'];
            Notify.error(error);
        }
        
        this.loading = false;
    },
})
